// D1 Client Operations for Practice History CRUD
// Connects with Cloudflare D1 storage endpoints asynchronously and manages the persistent state flow.

import { PracticeSession } from "../types";
import { savePracticeSessionToD1, clearPracticeHistoryFromD1, fetchPracticeHistoryFromD1, deletePracticeSessionFromD1 } from "./d1-sync";

/**
 * Persists a new or updated practice session into Cloudflare D1 SQL relational store
 * and keeps local storage synchronized for robust offline accessibility.
 */
export async function addPracticeSessionD1(session: PracticeSession): Promise<boolean> {
  try {
    return await savePracticeSessionToD1(session);
  } catch (err) {
    console.error("[D1 Client] Failed to add practice session to database.", err);
    return false;
  }
}

/**
 * Synchronizes a removal of a practice session across local storage and the serverless relational database.
 */
export async function removePracticeSessionD1(id: string): Promise<boolean> {
  try {
    return await deletePracticeSessionFromD1(id);
  } catch (err) {
    console.error(`[D1 Client] Failed to delete practice session ${id} from database.`, err);
    return false;
  }
}

/**
 * Truncates and clears all logs in the practice history from both local state and Cloudflare D1.
 */
export async function clearHistoryD1(): Promise<boolean> {
  try {
    return await clearPracticeHistoryFromD1();
  } catch (err) {
    console.error("[D1 Client] Failed to wipe history database.", err);
    return false;
  }
}

/**
 * Pulls the absolute, latest list of sessions directly from the relational table.
 */
export async function fetchHistoryD1(): Promise<PracticeSession[]> {
  try {
    return await fetchPracticeHistoryFromD1();
  } catch (err) {
    console.error("[D1 Client] Failed to pull session logs from database.", err);
    return [];
  }
}
